import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { Field, FieldArray, FieldProps, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ITransformer, ITransformerCompany } from '../../../../@types/model/transformer/transformer';
import StadiumButton from '../../../customComponents/button/StadiumButton';
import BudgetTablePaginationField from '../field/BudgetTablePagination';
import LPUBudgetFieldArray from '../field/LPUField';
import TransformerBudgetHelper, { ITransformerBudget, ILPUBudgetFormValues, ILPUBudget } from '../../../../@types/model/transformer/budget/budget';

interface ILPUBudgetFormProps {
    startDate : number;
    hideDetail : boolean;

    transformers : Array<ITransformer>;

    initialValue ?: ITransformerBudget | null;

    onSubmit : (value : ILPUBudgetFormValues) => void;
    
    company : ITransformerCompany;
    area : string;
    transformer : string | null;
    accountNumber : string | null;
    period : number | null;
}

const LPUBudgetForm = (props : ILPUBudgetFormProps) : React.ReactElement => {
    const [initialValue, setInitialValue] = useState<ILPUBudgetFormValues | null>(null);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(50);
    const [rowsPerPageOptions] = useState<Array<number>>([10, 20, 30, 50]);

    const setInit = () : void => {
        setInitialValue(
            TransformerBudgetHelper.initLPUForm(
                props.startDate,
                props.transformers,
                props.company,
                props.area,
                props.initialValue as ITransformerBudget<ILPUBudget>,
            ), 
        );
    };

    useEffect(() => {
        setInit();
    }, [props.startDate, props.company.id, props.area]);

    useEffect(() => {
        onPageChange(null, 0);
    }, [props.transformer, props.accountNumber, props.period]);

    const onSubmit = (values : ILPUBudgetFormValues) : void => {
        if (!props.onSubmit) return;
        props.onSubmit(values);
    };

    const onPageChange = (event : React.MouseEvent<HTMLButtonElement> | null, page : number) : void => {
        setCurrentPage(page);
    };

    const onRowsPerPageChange = (event ?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) : void => {
        if (!event) return;
        setRowsPerPage(Number(event.target.value));
    };

    return (
        <div className='fdc flx1'>
            {
                !!initialValue &&
                <Formik
                    initialValues={initialValue}
                    validationSchema={TransformerBudgetHelper.formLPUSchema()}
                    onSubmit={onSubmit}
                    validateOnBlur={false}
                    validateOnChange={false}
                    validateOnMount={false}
                    enableReinitialize
                >
                    {
                        (formik) => (
                            <div className='fdc flx1'>
                                {
                                    <div className='fdc flx1 budget bs oys'>
                                        <Table stickyHeader>
                                            <TableHead className='budget-table-header'>
                                                <TableRow>
                                                    <TableCell component='th' scope='row' className='bcg0' align='left' colSpan={4}>
                                                    </TableCell>
                                                    {
                                                        !props.hideDetail &&
                                                        <>
                                                            <TableCell component='th' scope='row' className='bcg0' align='left' colSpan={3}>
                                                            </TableCell>
                                                        </>
                                                    }
                                                    <TableCell className='lwb standard fwb' component='th' scope='row' align='center'>
                                                        STANDARD
                                                    </TableCell>
                                                    <TableCell className='lwb peak fwb' component='th' scope='row' align='center'>
                                                        PEAK
                                                    </TableCell>
                                                    <TableCell className='lwb off-peak fwb' component='th' scope='row' align='center'>
                                                        OFF PEAK
                                                    </TableCell>
                                                    <TableCell className='lwb total fwb' component='th' scope='row' align='center'>
                                                        TOTAL
                                                    </TableCell>
                                                    <TableCell className='bcg0' component='th' scope='row' align='left'>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ top: 57 }} component='th' scope='row' align='left' width={70}>
                                                        Period
                                                    </TableCell>
                                                    <TableCell style={{ top: 57 }} component='th' scope='row' align='left' width={100}>
                                                        Company
                                                    </TableCell>
                                                    <TableCell style={{ top: 57 }} component='th' scope='row' align='left' width={150}>
                                                        Area
                                                    </TableCell>
                                                    <TableCell style={{ top: 57 }} component='th' scope='row' align='left' width={70}>
                                                        EP Nr
                                                    </TableCell>
                                                    {
                                                        !props.hideDetail &&
                                                        <>
                                                            <TableCell style={{ top: 57 }} component='th' scope='row' align='left' width={150}>
                                                                Sub Area
                                                            </TableCell>
                                                            <TableCell style={{ top: 57 }} component='th' scope='row' align='left' width={100}>
                                                                Acc Nr
                                                            </TableCell>
                                                            <TableCell style={{ top: 57 }} component='th' scope='row' align='left' width={100}>
                                                                Season
                                                            </TableCell>
                                                        </>
                                                    }
                                                    <TableCell style={{ top: 57 }} className='lwb standard' component='th' scope='row' align='center'>
                                                        NEW STD BUDGET
                                                    </TableCell>
                                                    <TableCell style={{ top: 57 }} className='lwb peak' component='th' scope='row' align='center'>
                                                        NEW PEAK BUDGET
                                                    </TableCell>
                                                    <TableCell style={{ top: 57 }} className='lwb off-peak' component='th' scope='row' align='center'>
                                                        NEW OFF PEAK BUDGET
                                                    </TableCell>
                                                    <TableCell style={{ top: 57 }} className='lwb total' component='th' scope='row' align='center'>
                                                        NEW TOTAL BUDGET
                                                    </TableCell>
                                                    <TableCell style={{ top: 57 }} className='lwb bcp' component='th' scope='row' align='left'>
                                                        COMMENT
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody className='budget-table-body'>
                                                <FieldArray name='values'>
                                                    {
                                                        (array) => (
                                                            <LPUBudgetFieldArray
                                                                {...array}
                                                                accountNumber={props.accountNumber}
                                                                area={props.area}
                                                                company={props.company}
                                                                period={props.period}
                                                                currentPage={currentPage}
                                                                rowsPerPage={rowsPerPage}
                                                                transformer={props.transformer}
                                                                hideDetail={props.hideDetail}
                                                            />
                                                        )
                                                    }
                                                </FieldArray>
                                            </TableBody>
                                        </Table>
                                    </div>
                                }
                                <div className={'fdr aic'}>
                                    <span className='flx1'></span>
                                    <Field>
                                        {
                                            (params : FieldProps<unknown>) => (
                                                <BudgetTablePaginationField
                                                    {...params}
                                                    accountNumber={props.accountNumber}
                                                    area={props.area}
                                                    company={props.company}
                                                    period={props.period}
                                                    currentPage={currentPage}
                                                    rowsPerPage={rowsPerPage}
                                                    transformer={props.transformer}
                                                    rowsPerPageOptions={rowsPerPageOptions}
                                                    onPageChange={onPageChange}
                                                    onRowsPerPageChange={onRowsPerPageChange}
                                                />
                                            )
                                        }
                                    </Field>
                                </div>
                                <div className='fdr aife jcfe mt15'>
                                    <StadiumButton
                                        style={{
                                            height: 42,
                                            borderRadius: 40,
                                        }}
                                        className='jcc aic p0'
                                        color='primary'
                                        type='button'
                                        onClick={formik.submitForm}
                                        aria-label='Submit'
                                        disabled={formik.isSubmitting || !formik.isValid}
                                    >
                                        <Typography className='fw600 fs16 cp ml20 mr20'>SAVE</Typography>
                                    </StadiumButton>
                                </div>
                            </div>
                        )
                    }
                </Formik>

            }
        </div>
    );
};

export default LPUBudgetForm;